import get from 'lodash/get'
import request from '../../../request'
import { createAuthorization } from '../../../auth'

export async function getLanguages ({ auth, server }) {
  const res = await request
    .get(`${server}/notifications/language`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
  return get(res, 'body', [])
}
